import { IViewLayout } from "@faire/web-api/indigofair/data/IViewLayout";
import { WebClientSize } from "@faire/web-api/indigofair/data/WebClientSize";

export type SDUIUPLTComponentsPerClientSize = Record<WebClientSize, number>;

export const calculateNumUPLTComponentsPerClientSize = (
  viewLayout: IViewLayout
): SDUIUPLTComponentsPerClientSize => {
  const numberOfComponentsPerClientSize: Record<WebClientSize, number> = {
    [WebClientSize.MOBILE]: 0,
    [WebClientSize.TABLET]: 0,
    [WebClientSize.DESKTOP]: 0,
    [WebClientSize.XLARGE_DESKTOP]: 0,
    [WebClientSize.WEB_CLIENT_SIZE_UNKNOWN]: 0,
  };

  viewLayout.content.forEach((section) => {
    if (!section.is_required_for_interactivity || !section.column_section) {
      return;
    }

    section.column_section.components.forEach((component) => {
      if (!component.is_required_for_interactivity) {
        return;
      }

      const clientSizes =
        component.viewports.length === 0
          ? [
              WebClientSize.MOBILE,
              WebClientSize.TABLET,
              WebClientSize.DESKTOP,
              WebClientSize.XLARGE_DESKTOP,
              WebClientSize.WEB_CLIENT_SIZE_UNKNOWN,
            ]
          : component.viewports;

      clientSizes.forEach((clientSize) => {
        numberOfComponentsPerClientSize[clientSize] += 1;
      });
    });
  });

  return numberOfComponentsPerClientSize;
};
